/*
 * assets/js/src/hub-ilustrace.js — ilustrace s pohybem v hlavičce hubu (dev.16.55).
 *
 * Rozhodnutí majitele 23. 10. 2026 (hub Novoroční detox, varianta C):
 * ilustrace, přes ni smyčka videa (Kling), sníh a teplé světlo sálu.
 * Logika je z inline skriptu návrhu `novorocni-detox-hub-2026/navrh-vizual/
 * hero-navrh-detox.html` 1:1, jen jako modul téhož balíku.
 *
 * Běží jen na `.hubvis.ilustrace` (partial `template-parts/hub-ilustrace-2026.php`,
 * typ vizuálu `ilustrace-video`). Ostatní stránky modul nenajde.
 *
 * ---------------------------------------------------------------------
 * CO DĚLÁ
 * ---------------------------------------------------------------------
 *  1. Sníh: 26 vloček `.vlk` do `.snih` (pozice, velikost 3–8 px, trvání
 *     9–17 s, záporné zpoždění). Pohyb je čisté CSS (`za-snow`).
 *  2. Video: `src` dosadí až modul (šablona má `preload="none"` a jen
 *     `data-src`), pod 768 px menší soubor z `data-src-m`, je-li. Po
 *     `canplay` se video prolne přes obrázek (`.on`) a obrázek přestane
 *     driftovat (`.ma-video`); chyba = video pryč, zůstane obrázek.
 *  3. Parallax: proměnná `--p` na `<figure>` podle posunu (max 600), jen
 *     nad 1069 px — týž vzor jako stromek v `sneh.js`.
 *
 * `prefers-reduced-motion: reduce` = modul nevytvoří nic; zůstane statický
 * obrázek (video skrývá i CSS).
 *
 * Proměnné vloček přes `style.setProperty` (CSSOM), ne `style="…"`
 * v `innerHTML` — funguje i pod přísnou CSP.
 */

const SEL = '.hubvis.ilustrace';
const POCET = 26;

/**
 * Vločky do vrstvy `.snih`.
 *
 * @param {Element} vrstva Prvek `.snih`.
 */
function snih(vrstva) {
	for (let i = 0; i < POCET; i += 1) {
		const vl = document.createElement('span');
		vl.className = 'vlk';
		vl.style.setProperty('--x', `${(2 + Math.random() * 96).toFixed(1)}%`);
		vl.style.setProperty('--s', `${(3 + Math.random() * 5).toFixed(1)}px`);
		vl.style.setProperty('--d', `${(9 + Math.random() * 8).toFixed(1)}s`);
		vl.style.setProperty('--dl', `${(-Math.random() * 16).toFixed(1)}s`);
		vrstva.appendChild(vl);
	}
}

/**
 * Spustí smyčku videa nad obrázkem.
 *
 * @param {Element} fig Kořen `.hubvis.ilustrace`.
 * @param {HTMLVideoElement} vid Prvek `video.ladavid`.
 */
function video(fig, vid) {
	const mobil = window.matchMedia('(max-width: 767px)').matches;
	const src = mobil && vid.dataset.srcM ? vid.dataset.srcM : vid.dataset.src;
	if (!src) {
		vid.remove();
		return;
	}
	vid.addEventListener(
		'canplay',
		() => {
			fig.classList.add('ma-video');
			vid.classList.add('on');
			const hrani = vid.play();
			if (hrani && typeof hrani.catch === 'function') {
				hrani.catch(() => {});
			}
		},
		{ once: true }
	);
	vid.addEventListener('error', () => vid.remove(), { once: true });
	vid.src = src;
	vid.load();
}

/**
 * Nastaví jednu ilustraci.
 *
 * @param {Element} fig Kořen `.hubvis.ilustrace`.
 */
function setup(fig) {
	const vrstva = fig.querySelector('.snih');
	if (vrstva) {
		snih(vrstva);
	}
	const vid = fig.querySelector('video.ladavid');
	if (vid) {
		video(fig, vid);
	}
	if (window.innerWidth > 1069) {
		let ceka = false;
		window.addEventListener(
			'scroll',
			() => {
				if (ceka) {
					return;
				}
				ceka = true;
				window.requestAnimationFrame(() => {
					fig.style.setProperty('--p', String(Math.min(window.scrollY, 600)));
					ceka = false;
				});
			},
			{ passive: true }
		);
	}
}

/**
 * Spustí modul. Vrací počet ilustrací (kontrakt ostatních modulů).
 *
 * @returns {number}
 */
export function init() {
	const figs = document.querySelectorAll(SEL);
	if (!figs.length) {
		return 0;
	}
	if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
		return 0;
	}
	let count = 0;
	for (const fig of figs) {
		if (fig.dataset.zaIlustraceInit === '1') {
			continue;
		}
		fig.dataset.zaIlustraceInit = '1';
		setup(fig);
		count += 1;
	}
	return count;
}
